function gtag() {
    window.dataLayer.push(arguments);
}

export function fireDialEvent()
{
    console.log('Firing dial event');
    gtag('event', 'call_number', {
        'app_name': 'arnyekguru',
        'screen_name': 'Home'
    });
}